import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:43
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/mfa/enroll',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:43
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:43
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:43
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:43
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const enroll = {
    store: Object.assign(store, store),
}

export default enroll